import React from 'react';

import cx from 'classnames';
import * as Draft from 'draft-js';

import Icon from 'components/shared/Icon';
import AlignCenterIcon from 'components/shared/Icon/icons/AlignCenter';
import AlignJustifyIcon from 'components/shared/Icon/icons/AlignJustify';
import AlignLeftIcon from 'components/shared/Icon/icons/AlignLeft';
import AlignRightIcon from 'components/shared/Icon/icons/AlignRight';
import { useWysiwygContext } from 'components/shared/Wysiwyg/Wysiwyg.contex';

import { BaseItemButton } from '../Base';
import s from './Align.module.css';

type Props = {
  Icon: () => JSX.Element;
  type: 'center' | 'justify' | 'left' | 'right';
};

const Align = (props: Props) => {
  const { editor } = useWysiwygContext();
  const isActive = getCurrentBlockType(editor.editorState) === props.type;

  const onClick = () => {
    editor.handleChange(Draft.RichUtils.toggleBlockType(editor.editorState, props.type));
  };

  return (
    <BaseItemButton onClick={onClick} className={cx(isActive && s.active)}>
      <Icon component={props.Icon} />
    </BaseItemButton>
  );
};

const getCurrentBlockType = (editorState: Draft.EditorState): string => {
  const selectionState = editorState.getSelection();
  const contentState = editorState.getCurrentContent();
  const blockKey = selectionState.getStartKey();

  return contentState.getBlockForKey(blockKey).getType();
};

export const AlignCenter = () => <Align type="center" Icon={AlignCenterIcon} />;
export const AlignJustify = () => <Align type="justify" Icon={AlignJustifyIcon} />;
export const AlignLeft = () => <Align type="left" Icon={AlignLeftIcon} />;
export const AlignRight = () => <Align type="right" Icon={AlignRightIcon} />;

export const alignBlockStyleFn = (contentBlock: Draft.ContentBlock) => {
  const type = contentBlock.getType();

  if (type === 'left') return 'align-left';
  if (type === 'center') return 'align-center';
  if (type === 'right') return 'align-right';
  if (type === 'justify') return 'align-justify';

  return '';
};
